import { forwardRef } from 'react';

import { Button } from '@breezeventures/ui-kit/button';

import CalendarIcon from './calendar-icon.svg?react';

import { getFormattedRange } from '../../lib/get-formatted-range';

type Props = {
  value?: string;
  onClick?: () => void;
  size?: 's' | 'm';
};

const PLACEHOLDER = 'Select a period';

export const Trigger = forwardRef<HTMLButtonElement, Props>(
  ({ value, onClick, size = 'm' }, ref) => {
    const label = getFormattedRange(value) || PLACEHOLDER;

    return (
      <Button
        ref={ref}
        type="button"
        variant="secondary"
        size={size}
        onClick={onClick}
      >
        <Button.Icon>
          <CalendarIcon />
        </Button.Icon>
        {label}
      </Button>
    );
  }
);

Trigger.displayName = 'DateRangePickerTrigger';
